export type MillisecondRange = readonly [minimum: number, maximum: number]

export const RAIN_TIMING = {
  initialDry: [1_800, 5_200],
  dry: [8_000, 18_000],
  wet: [3_200, 6_400],
} as const satisfies Record<string, MillisecondRange>

export const RAIN_DROP_COUNT = 30

export type RainDrop = {
  id: number
  left: number
  length: number
  duration: number
  delay: number
  opacity: number
}

/** Return a duration inside a closed range, with injectable randomness for tests. */
export function randomMilliseconds(
  [minimum, maximum]: MillisecondRange,
  random: () => number = Math.random,
) {
  const unit = Math.min(1, Math.max(0, random()))
  return Math.round(minimum + (maximum - minimum) * unit)
}

/** Build one light shower. A new page load gets a new, evenly scattered field. */
export function createRainDrops(
  count = RAIN_DROP_COUNT,
  random: () => number = Math.random,
): RainDrop[] {
  return Array.from({ length: count }, (_, id) => ({
    id,
    left: random() * 100,
    length: 18 + random() * 34,
    duration: 0.82 + random() * 0.78,
    delay: -random() * 1.6,
    opacity: 0.2 + random() * 0.28,
  }))
}
